import React, { useState } from 'react';
import { Home, Droplets, Store, Users, FileText, Zap, TrendingUp, Star, Copy, Check, X, Train } from 'lucide-react';
import diamondImage from '../assets/images/diamond.png';
import './Pricing.css';

const Pricing: React.FC = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [copiedUsername, setCopiedUsername] = useState('');

  const handleContactClick = () => {
    const discordUsername = Math.random() < 0.5 ? 'snowylol_' : 'spookythenobody';
    navigator.clipboard.writeText(discordUsername);
    setCopiedUsername(discordUsername);
    setShowPopup(true);
    
    // Auto-hide popup after 3 seconds
    setTimeout(() => {
      setShowPopup(false);
    }, 3000);
  };

  const pricingTiers = [
    {
      id: 'residential',
      name: 'Residential Plot',
      description: 'Perfect for building your dream home',
      price: 32,
      popular: true,
      max: Infinity,
      features: [
        { icon: Home, text: 'Build your dream home' },
        { icon: Droplets, text: 'Access to town power' },
        { icon: Users, text: 'Join the community' },
        { icon: FileText, text: 'Free Resources' },
      ]
    },
    {
      id: 'commercial',
      name: 'Commercial Shop',
      description: 'Start your business in the town center',
      price: 16,
      max: 1,
      popular: false,
      features: [
        { icon: Store, text: '1 chunk shop space' },
        { icon: Zap, text: 'Free power included' },
        { icon: TrendingUp, text: 'Sell resources in town' },
        { icon: Train, text: 'Railway Access' },
      ]
    }
  ];

  return (
    <section id="pricing" className="pricing">
      <div className="container">
        <div className="pricing-header">
          <h2 className="section-title">Choose Your Plot</h2>
          <p className="section-description">
            Secure your place in our thriving Minecraft town with transparent, fair pricing for every need.
          </p>
        </div>
        
        <div className="pricing-grid">
          {pricingTiers.map((tier) => (
            <div key={tier.id} className={`pricing-card glass-card ${tier.popular ? 'popular' : ''}`}>
              {tier.popular && (
                <div className="popular-badge">
                  <Star size={16} />
                  Most Popular
                </div>
              )}
              
              <div className="card-header">
                <h3 className="tier-name">{tier.name}</h3>
                <p className="tier-description">{tier.description}</p>
              </div>
              
              <div className="price-section">
                <div className="price-display">
                  <img src={diamondImage} alt="Diamond" className="diamond-icon" />
                  <span className="price-number">{tier.price}</span>
                </div>
                <div className="price-unit">{tier.max === Infinity ? 'per chunk' : `per chunk (max ${tier.max})`}</div>
              </div>
              
              <div className="features-list">
                {tier.features.map((feature, index) => (
                  <div key={index} className="feature-item">
                    <div className="feature-icon">
                      <feature.icon size={18} />
                    </div>
                    <span className="feature-text">{feature.text}</span>
                  </div>
                ))}
              </div>
              
              <div className="card-footer">
                <button className="select-plan-btn" onClick={handleContactClick}>
                  Contact us on Discord
                </button>
              </div>
            </div>
          ))}
        </div>
        
        <div className="pricing-info">
          <div className="info-card glass-card">
            <div className="info-header">
              <img src={diamondImage} alt="Diamond" className="info-diamond" />
              <div>
                <h4>Pricing Information</h4>
                <p>Why we use diamonds and how you get your plot</p>
              </div>
            </div>
            <div className="info-details">
              <div className="info-item">
                <strong>Why Diamonds?</strong> Coins are unreliable, change price and lose value, diamonds simply retain their values.
              </div>
              <div className="info-item">
                <strong>Why us?</strong> We make farms accessible to everyone in our community, allowing to not have to worry about any of these resources.
              </div>
            </div>
          </div>
          
          <div className="contact-card glass-card">
            <h4>Ready to Join?</h4>
            <p>Contact <strong>snowylol_</strong> or <strong>spookythenobody</strong> on Discord to purchase your plot and start building your legacy!</p>
            <button className="contact-btn" onClick={handleContactClick}>
              Contact on Discord
            </button>
          </div>
        </div>
      </div>

      {/* Custom Popup */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <button className="popup-close" onClick={() => setShowPopup(false)}>
              <X size={20} />
            </button>
            <div className="popup-icon">
              <Check size={32} />
            </div>
            <h3>Username Copied!</h3>
            <p>Discord username <strong>{copiedUsername}</strong> has been copied to your clipboard.</p>
            <div className="popup-username">
              <Copy size={16} />
              {copiedUsername}
            </div>
            <p className="popup-instruction">Open Discord and start a conversation!</p>
          </div>
        </div>
      )}
    </section>
  );
};

export default Pricing; 